/*eslint-disable*/
import {request} from '@/utils/request/request'
export function ele1(query){
  return request({
      url:'api/tongji/v1/GetTongJiAndProjectInfo',
      method:'get',
      params:query
  })
}
